export const getComments = (comments, from) => {

    let NEW = [];
    let INREVIEW = [];
    let DONE = [];

    if (comments) {
      if (comments.length === 0) {
        return {
          NEW: [],
          INREVIEW: [],
          DONE: [],
        };
      }
      let currentComments = [...comments];

      if (currentComments) {
        currentComments?.map((comment) => {
          if (comment.feedbackStatus) {
            if (comment.feedbackStatus === "NEW") {
              NEW.push(comment);
            } else if (comment.feedbackStatus === "INREVIEW") {
              INREVIEW.push(comment);
            } else if (comment.feedbackStatus === "DONE") {
              DONE.push(comment);
            }
          }
        });

        return {
          NEW: NEW,
          INREVIEW: INREVIEW,
          DONE: DONE,
        };
      }
    } else {
      return {
        NEW: [],
        INREVIEW: [],
        DONE: [],
      };
    }
  };